import React, { useState } from 'react'
import { strings } from '../../../localization/strings'
import ConfigPanel from './configPanel'
import { Button } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import EmailTemplateCustomizer from './emailTemplateCustomizer'

const Component = ({ config, handleEdit }) => {
    const [open, setOpen] = useState(false)

    const handleChangeSmsCourier = (text) => {
        handleEdit({
            wasEdited: true,
            config: {
                ...config,
                notificationTemplateSmsCourier: text,
            },
        })
    }

    return (
        <>
            <ConfigPanel
                title={strings.configNotificationTemplateTitle}
                items={[
                    {
                        label: strings.configNotificationTemplateSmsCourier,
                        control: (
                            <TextField
                                value={
                                    config.notificationTemplateSmsCourier || ''
                                }
                                onChange={(e) =>
                                    handleChangeSmsCourier(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    maxLength:
                                        config.defaultNotificationTemplateSmsCourierMaxLength ||
                                        3,
                                }}
                                required
                            />
                        ),
                    },
                ]}
            />
            <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setOpen(true)}
            >
                {
                    strings.configNotificationTemplateEmail.templateEmailEditor
                }
            </Button>
            <EmailTemplateCustomizer
                open={open}
                onClose={() => setOpen(false)}
                config={config}
                handleEdit={handleEdit}
            />
        </>
    )
}

export default Component